/**
 * Renderer capability checks for Phaser 4.
 *
 * Phaser 4's Canvas renderer exposes some WebGL-only factory methods
 * (e.g. `scene.add.spriteGPULayer`) that exist at runtime but crash
 * internally when the actual WebGL context is absent. Guard on the
 * renderer type instead of checking for method existence.
 */
import * as Phaser from 'phaser';

/** Returns true when the game is running the WebGL renderer. */
export function isWebGL(scene: Phaser.Scene): boolean {
  return scene.renderer.type === Phaser.WEBGL;
}
